import React from 'react';
import ENUMS from '../../enums/index';
import PaymentDetails from './modals/paymentDetail';
import { connect } from 'react-redux';
import { formatter, enumHelper } from '../../utils';
import generateClassName from '../../utils/generateClassName';

class PaymentsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortype: 'desc',
      paymentDetailsOpen: false,
      selectedPaymentId: null,
      sortedColumn: '',
    };
  }

  renderStatus = status => {
    switch (ENUMS.BANK_STATUS.list.filter(enum_status => enum_status.value === status)[0].value) {
      case 'PENDING':
        return 'badge-warning';
      case 'ERROR':
        return 'badge-danger';
      case 'TRANSFERRING' | 'CANCEL_BY_CUSTOMER' | 'TIMEOUT':
        return 'badge-info';
      case 'PAID':
        return 'badge-success';
      default:
        break;
    }
  };
  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };
  closePaymentModal = () => {
    this.setState(() => ({
      paymentDetailsOpen: false,
    }));
  };

  displayPaymentDetailsModal = id => {
    let { paymentsList = [] } = this.props;
    let selectedPaymentId = paymentsList.filter(payment => payment.id == id)[0].id;
    this.setState({ paymentDetailsOpen: true, selectedPaymentId });
  };

  render() {
    let { paymentsList = [], pageNumber, pageSize, sortType } = this.props;
    return (
      <>
        <table className="table table-hover table-light table-striped">
          <thead>
          <tr>
            <th className="text-center">{locales('tables.row')}</th>
            <th onClick={() => this.sortTable('userFullName')} className="text-center pointer">
              <i
                name="userFullName"
                className={generateClassName('userFullName', this.state.sortedColumn, sortType)}
              />
              {locales('tables.fullName')}
            </th>
            <th onClick={() => this.sortTable('amount')} className="text-center pointer">
              <i name="amount" className={generateClassName('amount', this.state.sortedColumn, sortType)}/>
              {locales('tables.amount')}
            </th>
            <th className="text-center">{locales('tables.bank')}</th>
            <th onClick={() => this.sortTable('trackingNumber')} className="text-center pointer">
              <i
                name="trackingNumber"
                className={generateClassName('trackingNumber', this.state.sortedColumn, sortType)}
              />
              {locales('tables.trackingCodePayment')}
            </th>
            <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
              <i
                name="createdAt"
                className={generateClassName('createdAt', this.state.sortedColumn, sortType)}
              />
              {locales('tables.date')}
            </th>
            <th className="text-center">{locales('tables.time')}</th>
            <th onClick={() => this.sortTable('userMobileNumber')} className="text-center pointer">
              <i
                name="userMobileNumber"
                className={generateClassName('userMobileNumber', this.state.sortedColumn, sortType)}
              />
              {locales('fields.mobileNumber')}
            </th>
            <th className="text-center">{locales('tables.status')}</th>
            <th className="text-center"></th>
          </tr>
          </thead>
          <tbody>
          {paymentsList.length ? (
            paymentsList.map((payment, index) => (
              <tr key={payment.id}>
                <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                <td className="text-center">{payment.userFullName}</td>
                <td className="text-center">{formatter.numberWithCommas(payment.amount)}</td>
                <td className="text-center">
                  {enumHelper.convertEnumValueToTitle(ENUMS.BANK_NAMES.list, payment.bankPortalName)}
                </td>
                <td className="text-center direction-ltr">{payment.trackingNumber}</td>
                <td className="text-center">{payment.createdDate}</td>
                <td className="text-center">{payment.createdTime}</td>
                <td className="text-center">{payment.userMobileNumber}</td>
                <td className="text-center">
                    <span className={`badge ${this.renderStatus(payment.status)} p-1`}>
                      {enumHelper.convertEnumValueToTitle(ENUMS.BANK_STATUS.list, payment.status)}
                    </span>
                </td>
                <td title={locales('titles.moreDetails')}>
                  <i
                    onClick={() => this.displayPaymentDetailsModal(payment.id)}
                    className="text-center far fa-info-circle pointer"
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr className="col-12 text-center">
              <td className="alert alert-info" colSpan={12}>
                {locales('alerts.noRecord')}
              </td>
            </tr>
          )}
          </tbody>
        </table>
        {this.state.paymentDetailsOpen && (
          <PaymentDetails
            isOpen={this.state.paymentDetailsOpen}
            paymentId={this.state.selectedPaymentId}
            closeModal={this.closePaymentModal}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    paymentsList: state.paymentsReducer.paymentsList,
  };
};
export default connect(mapStateToProps)(PaymentsTable);
